import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { task } from 'ember-concurrency';
import AlertsService from 'cio/services/alerts';
import { getAudienceSummaryText } from 'cio/utils/campaigns/sumaries';
import SubjectModel from 'cio/models/subject';
import { AudienceSettingsType } from 'cio/models/campaign';

export default class SubjectController extends Controller {
  @service alerts!: AlertsService;

  declare model: SubjectModel;

  get canForceExit() {
    return this.model.isActive || this.model.isStarting;
  }

  forceExitSubjectTask = task(async () => {
    await this.model.forceExit({});
    await this.send('reloadModel');

    this.alerts.success('subject.forceExit.success', 'This journey has been ended.');
  });

  get audienceSummary() {
    return getAudienceSummaryText(this.model.campaign, this.model.campaign.objectTypeForCampaign, true);
  }

  get showAudienceConditions() {
    return this.model.campaign.audience?.type === AudienceSettingsType.filtered;
  }
}
